import React from "react";
import css from "./premium_course_card.module.scss";
import { IconAi } from "../icon/index";
import LockIcon from '@mui/icons-material/Lock';

const PremiumCourseCard = ({ 
  title = "AI · Foundations Reactor", 
  tag = "BEGINNER", 
  duration = "4h 0m", 
  level = "Intro", 
  modules = "6 mod",
  icon: Icon = IconAi,
  color = "#00f2ff",
  amount = "₹ 999",
  click = null
}) => {
  return (
    <div className={css.card_wrap} style={{ "--card-bg": color }} onClick={click}>
      <div className={css.header}>
        <div className={css.icon_container}>
          <Icon />
        </div>
        <div className={css.header_right}>
          <div className={css.lock_wrap}>
            <LockIcon />
          </div>
          <span className={css.tag}>{tag}</span>
        </div>
      </div>
      <h2 className={css.title}>{title}</h2>
      <div className={css.price_tag}>{amount}</div>
      <div className={css.divider} />
      <div className={css.footer}>
        <div className={css.footer_item}>
          <span className={css.icon_placeholder}>🕒</span>
          <span>{duration}</span>
        </div>
        <div className={css.footer_item}>
          <span className={css.icon_placeholder}>📊</span>
          <span>{level}</span>
        </div>
        <div className={css.footer_item_right}>
          <span>{modules}</span>
        </div>
      </div>
    </div>
  );
};

export default PremiumCourseCard;
